

<template>
  <div class="content">
     
    <h3>Dashboard Webhook</h3>
    <div class="btn-group btn-group-toggle float-right mb-3" data-toggle="buttons">
      <base-button
        @click="exportData"
        class="btn btn-round btn-just-icon btn-market"
      > Export Data  </base-button>
    </div>
    
    <!-- Score Banner -->
    <div class="card mb-4 border-0 shadow card-custom">
  <div class="bg-gradient-primary-2 text-white p-3">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="fas fa-trophy fa-3x mr-3"></i>
        <div>
          <h4 class="mb-0">Global Score 🏆</h4>
          <p class="mb-0 text-white-50"> {{ getScoreDescription(globalScore) }}  </p>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <h2 class="display-4 mb-0 font-weight-bold">{{ globalScore }}%</h2>
        <i class="fas fa-star fa-2x ml-2 text-warning"></i>
      </div>
    </div>
  </div>
</div>


    <!-- Filters -->
    <card>
      <div class="row">
          <base-input class="col-md-4">
            <el-date-picker v-model="StartDate" value-format="yyyy-MM-dd" type="date" :placeholder="$t('table.columns.Startdate').toUpperCase()"></el-date-picker>
          </base-input>
          <base-input class="col-md-4">
            <el-date-picker v-model="EndDate" value-format="yyyy-MM-dd" type="date" :placeholder="$t('table.columns.Enddate').toUpperCase()"></el-date-picker>
          </base-input>

           <!-- Client Filter -->
        <base-input class="col-md-3">
          <el-select 
            v-model="selectedClient" 
            filterable 
            clearable
            placeholder="Select Client" 
            @change="handleClientChange">
            <el-option
              v-for="client in clients"
              :key="client.pk_annonceur"
              :label="client.societe"
              :value="client.pk_annonceur">
            </el-option>
          </el-select>
          </base-input>
          <base-input>
                        <el-select
                            filterable
                            class="select-primary"
                            v-model="CategorieSelects.Categorie"
                             
                            :placeholder="
                                $t('table.columns.Product').toUpperCase()
                            "
                            @change="handleClientChange2"
                            clearable
                        >
                            <el-option
                                v-for="option in CategorieSelects.ListCategorie"
                                class="select-primary text-uppercase"
                                :value="option.pk_categorie"
                                :label="option.designation.replace(/Ã©/g, 'é')"
                                :key="option.pk_categorie"
                            >
                            </el-option>
                        </el-select>
                    </base-input>
          <div class="col-md-2">
            <base-button 
                class="btn-primary"
                @click="fetchLeviersStats">
                Rechercher
            </base-button>
         </div>
      </div>
        
        <!-- Filters Dropdown -->
        
        
       
  
 
                 <!-- Search -->
                 <div class="row mt-3">
                <!--<div class="col-12">
                        <base-input>
                            <el-input
                                type="search"
                                class="search-input"
                                clearable
                                prefix-icon="el-icon-search"
                                :placeholder="$t('buttons.BtnSearch2') || 'SEARCH'"
                                v-model="searchQuery"
                                @input="filterData"
                                @clear="filterData()">
                            </el-input>
                        </base-input>
                    </div>-->
                </div>
              </card>
<card>
  <!-- Loading Overlay -->
  <div v-if="loadingStats" class="loading-overlay">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin fa-3x"></i>
        <p class="mt-2">Loading data...</p>
      </div>
    </div>
    
     <!-- Data Table -->
     <el-table 
        :data="displayData" 
        row-class-name="stats-table-rows" 
        v-loading="loading"
        :row-class-name="getRowClass"
        @sort-change="sortChange"
      >
      <!-- Colonne Source -->
      <el-table-column prop="source" label="Source" min-width="100" sortable="custom">
        <template slot-scope="scope">
          <div class="pl-5" :class="{'font-weight-bold': scope.row.isTotal}">
            <span v-if="!scope.row.isTotal">{{ scope.row.emoji }} {{ scope.row.source }}</span>
            <span v-else>📊 TOTAL</span>
          </div>
        </template>
      </el-table-column>
      
      <!-- Colonne d'expansion -->
      <el-table-column type="expand">
        <template slot-scope="props">
          <div v-if="!props.row.isTotal">
          <el-table 
            v-if="!props.row.isTotal"
            :data="props.row.subSources" 
            class="sub-sources-table"
            :show-header="false"
          >
            <!-- Sous-Source -->
            <el-table-column prop="source" min-width="180">
              <template slot-scope="scope">
                <div class="pl-5">
                  <span>{{ scope.row.emoji }} {{ scope.row.source }}</span>
                </div>
              </template>
            </el-table-column>
            
            <!-- Leads pour sous-sources -->
            <el-table-column prop="total_leads" label="Leads" width="100">
              <template slot-scope="scope">
                <span :class="{'font-weight-bold': true, 'text-danger': isZeroValue(scope.row.total_leads)}">
                  {{ scope.row.total_leads }}</span>
              </template>
            </el-table-column>
            

            <!-- leads statué -->
            <el-table-column prop="percentage" label="Leads statué" width="80">
              <template slot-scope="scope">
                  <span :class="{'font-weight-bold': true, 'text-danger': isZeroValue(scope.row.leads_statue) || isZeroValue(calculatePercentage(scope.row.leads_statue, scope.row.total_leads))}">

                 {{ scope.row.leads_statue }}
                </span>
              </template>
            </el-table-column>
            <!-- Pourcentage pour sous-sources -->
            <el-table-column prop="percentage" label="%" width="80">
              <template slot-scope="scope">
                  <span :class="{'font-weight-bold': true, 'text-danger': isZeroValue(scope.row.leads_statue) || isZeroValue(calculatePercentage(scope.row.leads_statue, scope.row.total_leads))}">

                  {{  calculatePercentage(scope.row.leads_statue, scope.row.total_leads) }}%
                </span>
              </template>
            </el-table-column>
            
            <!-- Score pour sous-sources -->
            <el-table-column prop="total_score" label="Score" width="100">
              <template slot-scope="scope">
                <span :class="{'font-weight-bold': true, 'text-danger': isZeroValue(scope.row.score)}">
                  {{ scope.row.score }} ⭐</span>
              </template>
            </el-table-column>
            
            <!-- Score moyen pour sous-sources -->
            <el-table-column prop="score" label="Score moyen" width="120">
              <template slot-scope="scope">
                <span :class="{'font-weight-bold': true, 'text-danger': isZeroValue(scope.row.score_moyen)}">
                 - <!--{{ scope.row.score_moyen }} ⭐--></span>
              </template>
            </el-table-column>
            
            <!-- Taux de transfo pour sous-sources -->
            <el-table-column prop="transformationRate" label="Taux de transfo" width="150">
              <template slot-scope="scope">
                <span :class="getStatusColorClass(scope.row.transformationRate)"  :title="scope.row.positiveLeads">
                 {{ calculatePercentage(scope.row.positiveLeads, scope.row.leads_statue) }}% 📈
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else></div>
        </template>
      </el-table-column>
      
      <!-- Leads -->
      <el-table-column
        prop="total_leads"
        label="Leads"
        sortable="custom"
        width="100"
      >
        <template slot-scope="scope">
          <span :class="{'font-weight-bold': true, 'text-primary': scope.row.isTotal}">
            {{ scope.row.total_leads }} 
          </span>
        </template>
      </el-table-column>
      
      <!-- total lead statue (%) -->
      <el-table-column
        prop="leads_statue"
        label="Leads statué"
        sortable="custom"
        width="80"
      >
        <template slot-scope="scope">
          <span :class="{'font-weight-bold': true, 'text-primary': scope.row.isTotal}" :title="scope.row.leads_statue">
            {{ scope.row.leads_statue }}
          </span>
        </template>
      </el-table-column>
      <!-- Pourcentage (%) -->
      <el-table-column
        prop="percentage"
        label="%"
        sortable="custom"
        width="80"
      >
        <template slot-scope="scope">
          <span :class="{'font-weight-bold': true, 'text-primary': scope.row.isTotal}" :title="scope.row.leads_statue">
            {{ calculatePercentage(scope.row.leads_statue, scope.row.total_leads) }}% 
          </span>
        </template>
      </el-table-column>
      
      <!-- Score -->
      <el-table-column
        prop="total_score"
        label="Score"
        sortable="custom"
        width="100"
      >
        <template slot-scope="scope">
          <span :class="{'font-weight-bold': true, 'text-primary': scope.row.isTotal}">
            {{ scope.row.score }}⭐
          </span>
        </template>
      </el-table-column>
      
      <!-- Score moyen -->
      <el-table-column
        prop="score"
        label="Score moyen"
        sortable="custom"
        width="120"
      >
        <template slot-scope="scope">
          <span :class="{'font-weight-bold': true, 'text-primary': scope.row.isTotal}">
            - <!--{{ scope.row.score_moyen }} ⭐-->
          </span>
        </template>
      </el-table-column>
      
      <!-- Taux de transfo -->
      <el-table-column
        prop="transformationRate"
        label="Taux de transfo"
        sortable="custom"
        width="150"
      >
        <template slot-scope="scope">
          <span :class="[getStatusColorClass(scope.row.transformationRate), {'text-primary': scope.row.isTotal}]"  :title="scope.row.positiveLeads">
            {{ scope.row.transformationRate }}% 📈
          </span>
        </template>
      </el-table-column>
    </el-table>
      <!-- Pagination -->
          <!--   <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            {{ $t('labels.Datatable.Showing') || 'Showing' }} {{ from + 1 }} {{ $t('labels.Datatable.to') || 'to' }} {{ to }} {{ $t('labels.Datatable.of') || 'of' }} {{ total }} {{ $t('labels.Datatable.entries') || 'entries' }}
          </p>
        </div>
        <base-pagination
          type="market"
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </base-pagination>
      </div>-->
    </card>

    <!-- Chart -->
    <!-- 1. Fix the Chart Component - add the :key property to force update -->
    <card class="mt-4">
      <template slot="header">
    <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Source Performance 📊</h5>
      <!--<el-radio-group v-model="chartView" size="small">
        <el-radio-button label="graph">Graphique</el-radio-button>
        <el-radio-button label="table">Tableau</el-radio-button>
      </el-radio-group>-->
    </div>
      </template>
  
  <!-- Updated line-chart with key for reactivity -->
      <line-chart
    v-if="chartView === 'graph'"
        :chart-data="chartData"
        :options="chartOptions"
    :key="chartUpdateKey"
        class="chart-container"
      ></line-chart>
  
  <!-- Add a Table View alternative when no data or as option -->
  <el-table
    v-if="chartView === 'table'" 
    :data="filteredSourceData.filter(item => !item.isTotal)" 
    style="width: 100%"
    border
    stripe
  >
    <el-table-column prop="source" label="Source" min-width="120" sortable="custom">
      <template slot-scope="scope">
        <div class="d-flex align-items-center">
          <span>{{ scope.row.emoji }} {{ scope.row.source }}</span>
        </div>
      </template>
    </el-table-column>
    
    <el-table-column prop="total_leads" label="Leads" width="100" sortable="custom">
      <template slot-scope="scope">
        <span :class="{'text-danger': isZeroValue(scope.row.total_leads)}">
          {{ scope.row.total_leads }}
        </span>
      </template>
    </el-table-column>
    
    <el-table-column prop="leads_statue" label="Leads statué" width="120" sortable="custom">
      <template slot-scope="scope">
        <span :class="{'text-danger': isZeroValue(scope.row.leads_statue)}">
          {{ scope.row.leads_statue }}
        </span>
      </template>
    </el-table-column>
    
    <el-table-column label="%" width="80" sortable="custom">
      <template slot-scope="scope">
        <span :class="{'text-danger': isZeroValue(calculatePercentage(scope.row.leads_statue, scope.row.total_leads))}">
          {{ calculatePercentage(scope.row.leads_statue, scope.row.total_leads) }}%
        </span>
      </template>
    </el-table-column>
  </el-table>

  <!-- Empty state message -->
  <!--<div v-if="filteredSourceData.length === 0 || (chartView === 'graph' && !hasValidChartData)" 
       class="text-center p-5">
    <i class="fas fa-chart-bar fa-3x text-muted mb-3"></i>
    <p class="text-muted">Aucune donnée à afficher. Veuillez ajuster vos filtres ou sélectionner une autre période.</p>
  </div>-->
    </card>
    
    <!-- Details Modal -->
    <modal
      :show.sync="showDetailsModal"
      footerClasses="justify-content-center"
      body-classes="p-0"
      modalClasses="modal-dialog-centered"
      class="modal-listbase"
    >
      <card class="border-0 mb-0 py-3 fixed-min-height">
        <template slot="header">
          <el-tooltip
            :content="$t('labels.closeModal') || 'Close'"
            effect="light"
            :open-delay="300"
            placement="top"
          >
            <base-button
              @click.native="closeModal"
              class="btn-link float-right"
              type="danger"
              size="sm"
              icon
            >
              <i class="tim-icons icon-simple-remove"></i>
            </base-button>
          </el-tooltip>
        </template>
        <h3 slot="header" class="modal-title pt-3 text-center">
          {{ selectedSource ? `${selectedSource.emoji} ${selectedSource.source} Details` : 'Source Details' }}
        </h3>
        
        <div v-if="selectedSource" class="p-3">
          <div class="row">
            <div class="col-md-6">
              <h6 class="font-weight-bold">Performance Metrics</h6>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Score:</span>
                <span class="font-weight-bold" >{{ selectedSource.score }} ⭐</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Transformation Rate:</span>
                <span :class="getStatusColorClass(selectedSource.transformationRate)">
                  {{ selectedSource.transformationRate }}% 📈
                </span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">ROI:</span>
                <span class="text-purple">{{ selectedSource.roi }}% 💰</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Trend:</span>
                <span class="text-success">{{ selectedSource.trend }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <h6 class="font-weight-bold">{{ $t('labels.actionItems') || 'Action Items' }}</h6>
              <ul class="pl-3">
                <li>{{ $t('labels.optimizeCampaigns') || 'Optimize campaigns' }}</li>
                <li>{{ $t('labels.analyzeAudience') || 'Analyze audience segments' }}</li>
                <li>{{ $t('labels.adjustBudget') || 'Adjust budget allocation' }}</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="text-center mt-3">
          <base-button
            type="info"
            @click.native="closeModal"
          >{{ $t('buttons.close') || 'CLOSE' }}</base-button>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Dropdown, DropdownMenu, DropdownItem, RadioGroup, RadioButton, DatePicker } from 'element-ui'
import { BasePagination, Modal, BaseAlert } from 'src/components';
import { Line } from 'vue-chartjs'
import Fuse from 'fuse.js';
import moment from 'moment'
import gql from "graphql-tag";

export default {
  name: 'LeadMasterDashboard',
  apollo: {
        produits: {
            client: "MARKET",
            query: gql`
                query {
                    produits {
                        pk_categorie
                        designation
                    }
                }
            `,
            result({ data, loader, networkStatus }) {
                this.CategorieSelects.ListCategorie = data.produits;
                //console.log(data.produits);
            },
        }
      },      
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [DatePicker.name]: DatePicker,
    BasePagination,
    Modal,
    BaseAlert,
    LineChart: {
      extends: Line,
      mounted() {
        this.renderChart(this.chartData, this.options)        
      },
      props: {
        chartData: {
          type: Object,
          required: true
        },
        options: {
          type: Object,
          default: null
        }
      }
    }
  },
  watch: {
    searchQuery: {
      handler(value) {
        this.filterData();
      },
      immediate: true
    },
    'sourceData.overview': {
      handler() {
        this.initializeSearch();
        this.filterData();
      },
      deep: true
    },
    selectedPeriod(value) {
      // Update chart data based on selected period
      this.updateChartData();
    }
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.filteredSourceData.length;
    },
    chartData() {
    // Only include non-total rows and filter based on current filters
    const chartSources = this.filteredSourceData.filter(item => !item.isTotal);
    
      return {
      labels: chartSources.map(item => item.source),
        datasets: [
          {
          label: 'Leads 👥',
          backgroundColor: 'rgba(54, 162, 235, 0.4)',
          borderColor: '#36A2EB',
          borderWidth: 2,
          data: chartSources.map(item => item.total_leads)
          },
          {
          label: 'Leads statué 📋',
          backgroundColor: 'rgba(75, 192, 192, 0.4)',
          borderColor: '#4BC0C0',
          borderWidth: 2,
          data: chartSources.map(item => item.leads_statue)
        },
        {
          label: 'Taux (%) 📊',
          backgroundColor: 'rgba(153, 102, 255, 0.4)',
          borderColor: '#9966FF',
          borderWidth: 2,
          data: chartSources.map(item => 
            this.calculatePercentage(item.leads_statue, item.total_leads))
          }
        ]
    };
    },
  
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
      },
      tooltips: {
        callbacks: {
          label: function(tooltipItem, data) {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const value = dataset.data[tooltipItem.index];
            
            if (dataset.label.includes('%')) {
              return `${dataset.label}: ${value}%`;
            }
            
            return `${dataset.label}: ${value}`;
        }
      }
    }
    };
  }, 
  sourceCount() {
    return this.filteredSourceData.filter(item => !item.isTotal).length;
  },
   // Calcule les totaux et ajoute une ligne de total aux données filtrées
   displayData() {
      const data = this.filteredSourceData.slice(this.from, this.to);
      
      // Si pas de données, retourner un tableau vide
      if (data.length === 0) {
        return [];
      }
      
      // Calcul des totaux
      const totalRow = {
        isTotal: true,
        source: 'TOTAL',
        emoji: '📊',
        total_leads: 0,
        leads_statue: 0,
        score: 0,
        score_moyen: 0,
        transformationRate: 0,
        subSources: []
      };
      
      // Somme des valeurs pour chaque champ
      let totalLeads = 0;
      let totalLeadsStatue = 0;
      let weightedScore = 0;
      let weightedScoreMoyen = 0;
      let weightedTransformationRate = 0;
      
      data.forEach(row => {
        // Ne pas compter les lignes qui sont déjà des totaux
        if (row.isTotal) return;
        
        totalLeads += row.total_leads || 0;
        totalLeadsStatue += row.leads_statue || 0;
        
        // Score pondéré par le nombre de leads
        weightedScore += (row.score || 0); //* (row.total_leads || 0);
       // alert( this.sourceCount);
        // Score moyen pondéré
        weightedScoreMoyen += (row.score_moyen || 0);// * (row.total_leads || 0);
        
        // Taux de transformation pondéré
        weightedTransformationRate += (row.positiveLeads || 0 );//* (row.total_leads || 0
        
      });
      
      // Mise à jour des propriétés du total
      totalRow.total_leads = totalLeads;
      totalRow.leads_statue = totalLeadsStatue;
      
      // Calcul des moyennes pondérées
      if (totalLeads > 0) {
        totalRow.score = (weightedScore/this.sourceCount).toFixed(1);
        totalRow.score_moyen = Number((weightedScoreMoyen/this.sourceCount ).toFixed(1));/// totalLeads
        if(totalLeadsStatue>0){
          totalRow.transformationRate = (Number((weightedTransformationRate / totalLeadsStatue)*100).toFixed(1));

        }else totalRow.transformationRate =0;
      }

      if(totalLeadsStatue>0){
        this.globalScore =(Number((weightedTransformationRate / totalLeadsStatue)*100).toFixed(1));
      }else this.globalScore =0;

     
      // Ajoute la ligne de total à la fin
      return [...data, totalRow];
    }
  }
,
  data() {
    return {
      loading: false,
      showDetailsModal: false,
      selectedSource: null,
      selectedPeriod: '30j',
      activeFilters: [],
      loadingStats: false, 
      searchQuery: '',
      filteredSourceData: [],
       chartView: 'graph',
       CategorieSelects: {
                Categorie: "",
                ListCategorie: [],
            },
       chartUpdateKey: 0, // For forcing chart refresh
      periods: [
        { id: '7j', label: '7 days 📅' },
        { id: '30j', label: '30 days 📆' },
        { id: '90j', label: '90 days 📋' },
        { id: 'custom', label: 'Custom ⚡' }
      ],
      EndDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      StartDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      showPeriodSelector: false,
     
      filterOptions: {
        sources: ['SEA 🎯', 'Facebook 👥', 'Bing 🎵'],
        status: ['Converted ✅', 'In Progress 🔄', 'Unreachable ❌'],
        quality: ['Excellent ⭐', 'Good ⭐', 'Average ⭐']
      },
      sourceData: {
        overview: [],
        trends: Array.from({ length: 30 }, (_, i) => ({
          date: `2024-02-${String(i + 1).padStart(2, '0')}`,
          performance: 85 + Math.random() * 10,
          leads: 120 + Math.random() * 50
        }))
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      fuseSearch: null,
      options: {
        threshold: 0.3,
        isCaseSensitive: false,
        includeScore: true,
        shouldSort: true,
        includeMatches: false,
        findAllMatches: false,
        minMatchCharLength: 1,
        location: 0,
        distance: 100,
        useExtendedSearch: true,
        ignoreLocation: true,
        keys: [
          "source",
          "score",
          "transformationRate",
          "roi",
          "trend",
          "subSources.source"
        ]
      },
     customDateRange: {
      from: new Date(new Date().setDate(new Date().getDate() - 30)), // Par défaut à 30 jours avant aujourd'hui
      to: new Date() // Aujourd'hui
     }, 
     columnWidths: {
      source: '', // Auto ou valeur spécifique
      score: '100px',
      transformationRate: '200px',
      roi: '100px',
      actions: '170px'
    },
    globalScore: 0,
    // Client filter related data
      clients: [],
      selectedClient: null,
      client_id: null,
      categorie: null,
         
    }
  },
  mounted() {
    this.initializeSearch();
    this.filterData();
    this.fetchLeviersStats();
    this.fetchClients();
  },
  methods: {
    // Nouvelle méthode pour générer des données statiques positives
generateStaticPositiveData() {
  // Sources principales avec leurs icônes et données positives
  const sourcesData = [
    {
      source: "SOCIAL",
      emoji: "👥",
      total_leads: 548,
      leads_statue: 522,
      score: 4.8,
      score_moyen: 4.5,
      positiveLeads: 417,
      transformationRate: 79.8,
      isTotal: false
    },
    {
      source: "SEA",
      emoji: "🎯",
      total_leads: 763,
      leads_statue: 729,
      score: 4.6,
      score_moyen: 4.2,
      positiveLeads: 547,
      transformationRate: 75.0,
      isTotal: false
    },
    {
      source: "SEO",
      emoji: "📸",
      total_leads: 412,
      leads_statue: 395,
      score: 4.5,
      score_moyen: 4.0,
      positiveLeads: 276,
      transformationRate: 69.8,
      isTotal: false
    },
    {
      source: "SMS",
      emoji: "💼",
      total_leads: 324,
      leads_statue: 312,
      score: 4.7,
      score_moyen: 4.3,
      positiveLeads: 240,
      transformationRate: 76.9,
      isTotal: false
    },
    {
      source: "AFFILIATION",
      emoji: "📧",
      total_leads: 586,
      leads_statue: 552,
      score: 4.2,
      score_moyen: 3.9,
      positiveLeads: 397,
      transformationRate: 71.9,
      isTotal: false
    }
  ];

  // Ajouter des sous-sources à chaque source principale
  return sourcesData.map(source => {
    // Créer 2-3 sous-sources pour chaque source principale
    const subSourceCount = 2 + Math.floor(Math.random() * 2); // 2 ou 3
    const subSources = [];
    
    for (let i = 0; i < subSourceCount; i++) {
      const totalLeads = Math.floor(source.total_leads / subSourceCount) + Math.floor(Math.random() * 50);
      const leadsStatue = Math.floor(totalLeads * (0.92 + Math.random() * 0.08)); // Entre 92% et 100%
      const positiveLeads = Math.floor(leadsStatue * (0.65 + Math.random() * 0.25)); // Entre 65% et 90%
      
      subSources.push({
        source: `${source.source} ${['Campaign', 'Audience', 'Placement'][i % 3]} ${i+1}`,
        emoji: source.emoji,
        total_leads: totalLeads,
        leads_statue: leadsStatue,
        score: (source.score - 0.2 + Math.random() * 0.4).toFixed(1),
        score_moyen: (source.score_moyen - 0.2 + Math.random() * 0.4).toFixed(1),
        positiveLeads: positiveLeads,
        transformationRate: (positiveLeads / leadsStatue * 100).toFixed(1)
      });
    }
    
    return {
      ...source,
      subSources: subSources
    };
  });
},
    // Ajoutez cette nouvelle méthode dans la section methods
    // Méthode personnalisée de tri
  customSort(prop, order) {
    // Créer une copie de TOUTES les données
    const fullData = [...this.filteredSourceData];
    
    // Séparer les totaux
    const totalRows = fullData.filter(row => row.isTotal);
    let dataWithoutTotal = fullData.filter(row => !row.isTotal);

    // Trier les données hors totaux
    dataWithoutTotal = dataWithoutTotal.sort((a, b) => {
      let valA, valB;
      
      // Gestion spécifique selon la propriété à trier
      switch(prop) {
        case 'percentage':
          // Pour la colonne pourcentage (%)
          valA = this.calculatePercentage(a.leads_statue, a.total_leads);
          valB = this.calculatePercentage(b.leads_statue, b.total_leads);
          break;
          
        case 'score':
          // Pour le score
          valA = a.score;
          valB = b.score;
          break;

        case 'total_score':
          // Pour le score
          valA = a.score;
          valB = b.score;
          break; 
          
        case 'transformationRate':
          // Pour le taux de transformation
          valA = a.transformationRate;
          valB = b.transformationRate;
          break;
          
        case 'source':
          // Pour le tri par source (texte)
          valA = a.source;
          valB = b.source;
          break;
          
        default:
          // Pour les autres colonnes
          valA = a[prop];
          valB = b[prop];
          break;
      }

      // Vérification des valeurs null/undefined
      if (valA === null || valA === undefined) valA = order === 'ascending' ? Infinity : -Infinity;
      if (valB === null || valB === undefined) valB = order === 'ascending' ? Infinity : -Infinity;

      // Gestion des valeurs numériques
      if (typeof valA === 'number' && typeof valB === 'number') {
        return order === 'ascending' ? valA - valB : valB - valA;
      }
      
      // Gestion des valeurs textuelles
      const strA = String(valA);
      const strB = String(valB);
      
      return order === 'ascending' 
        ? strA.localeCompare(strB, undefined, {numeric: true, sensitivity: 'base'}) 
        : strB.localeCompare(strA, undefined, {numeric: true, sensitivity: 'base'});
    });

    // Fusionner les données triées avec les totaux
    this.filteredSourceData = [...dataWithoutTotal, ...totalRows];
  },
  
  // Gestionnaire d'événement de changement de tri - version sans déstructuration
  sortChange(params) {
    if (!params.prop || !params.order) return;
    this.customSort(params.prop, params.order);
  },
    // Fetch clients from the database
    fetchClients() {
      this.loading = true;
      let accessToken = localStorage.getItem("token_jwt");
      
      this.axios
        .get("https://apileadmarket.wee-do-it.net/api/clients-webhook", {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        })
        .then((response) => {
        
          if (Array.isArray(response.data)) {
            this.clients = response.data; // ✅ Correction ici
          } else {
            console.error("Unexpected response structure:", response.data);
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
          this.loading = false;
        });
    },
   // Handle client selection change
   handleClientChange() {
      this.client_id = this.selectedClient;
      this.fetchLeviersStats(); // Always fetch data, with or without a client selected
    },
    handleClientChange2() {
      this.categorie = this.CategorieSelects.Categorie;
        
      this.fetchLeviersStats(); // Always fetch data, with or without a client selected
    },
    calculateScorePerSource(score) {
        if (!this.sourceCount || this.sourceCount === 0) {
          return 0;
        }
        return (score / this.sourceCount).toFixed(2);
      },
    // Force chart to update when data changes
  refreshChart() {
    this.chartUpdateKey++; // Increment the key to force chart redraw
  },
    // Add this new method to check for zero values
    isZeroValue(value) {
      return value === 0 || value === '0' || value === 0.0 || value === '0.0';
    },
     // Add this method for sub-source specific status class that includes zero check
     getSubSourceStatusClass(value) {
      if (this.isZeroValue(value)) return 'text-danger';
      if (value >= 70) return 'text-success';
      if (value >= 50) return 'text-warning';
      return 'text-danger';
    },
    initializeSearch() {
      this.fuseSearch = new Fuse(this.sourceData.overview, this.options);
    },
    filterData() {
       // Start with the original data
       let result = this.sourceData.overview;
      
          // Apply search filter if there's a query and the search is initialized
          if (this.searchQuery && this.searchQuery.trim() !== '') {
            if (this.fuseSearch) {
              console.log('Searching for:', this.searchQuery);
              const searchResults = this.fuseSearch.search(this.searchQuery);
              console.log('Search results:', searchResults.length);
              
              // Extract the actual items from the search results
              result = searchResults.map(hit => hit.item);
            } else {
              console.warn('Search not initialized yet');
              // Try to initialize search if not already done
              this.initializeSearch();
              
    // Refresh chart to reflect filtered data
    this.refreshChart();
            }
          }
          
          // Apply any active filters (to be implemented based on your needs)
          console.log('Filtered results:', result.length);
          
          // Update the filtered data
          this.filteredSourceData = result;
          
          // Reset pagination to first page when filtering
          this.pagination.currentPage = 1;
    },
    calculatePercentage(part, total) {
      if (!total || total === 0) return '0';
      //console.log(part, total);
      return Math.round((part / total) * 100);
    },
    updateChartData() {
      // This would update the chart data based on the selected period
      // For demo purposes, we're not implementing the actual logic
      console.log(`Period changed to ${this.selectedPeriod}`);
    },
    handleFilterCommand(command) {
      console.log(`Filter selected: ${command}`);
      // Implement filter logic here
    },
    exportData() {

      // Set loading state
        this.loadingStats = true;
        let url = new URL("https://apileadmarket.wee-do-it.net/api/export-leads-webhook");

        // Create URL with query parameters
        const params = new URLSearchParams();

        // Add parameters
        if (this.client_id !== undefined && this.client_id !== null && this.client_id !== '') {
          params.append("client_id", this.client_id);
        }
        params.append("date_debut", this.StartDate);
        params.append("date_fin", this.EndDate);

        // Get the full URL with parameters
        const fullUrl = `${url.toString()}?${params.toString()}`;
                
     
          // Open in a new window/tab
          const newWindow = window.open(fullUrl, '_blank');
          
          // If popup blocked, provide a clickable link
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            // Popup was blocked
            console.log('Popup blocked. Please use the link below:');
            this.$emit('download-blocked', fullUrl);
          }
          
          this.loadingStats = false;
    
      console.log('Export data');
    },
    viewDetails(row) {
      this.selectedSource = row;
      this.showDetailsModal = true;
    },
    downloadReport(row) {
      console.log(`Downloading report for ${row.source}`);
      // Implement download functionality
    },
    shareReport(row) {
      console.log(`Sharing report for ${row.source}`);
      // Implement share functionality
    },
    closeModal() {
      this.showDetailsModal = false;
      this.selectedSource = null;
    },
    customSortMethod(a, b, prop) {
      // Convert to lowercase for case-insensitive sorting
      const valueA = a[prop] ? String(a[prop]).toLowerCase() : '';
      const valueB = b[prop] ? String(b[prop]).toLowerCase() : '';

      // Comparison
      if (valueA < valueB) return -1;
      if (valueA > valueB) return 1;
      return 0;
    },
    getPerformanceIconClass(score) {
      if (score >= 4.5) return 'fas fa-stars text-warning';
      if (score >= 4.0) return 'fas fa-star text-primary';
      return 'fas fa-thumbs-up text-success';
    },
    getStatusColorClass(value) {
      if (value >= 70) return 'text-success';
      if (value >= 50) return 'text-warning';
      return 'text-danger';
    },
    selectPeriod(periodId) {
      this.selectedPeriod = periodId;
      this.showPeriodSelector = false;
      this.updateChartData();
    },
    updateCustomDateRange() {
        if (this.customDateRange.from && this.customDateRange.to) {
            console.log('Custom date range updated:', this.customDateRange);
            this.updateChartData(); // Met à jour les données du graphique avec la plage personnalisée
        }
    },
    // Méthode pour appliquer une classe spéciale à la ligne de total
    getRowClass({ row }) {
     // return row.isTotal ? 'total-row' : '';
      if (row.isTotal) {
        return 'total-row no-expand';
      }
      return '';  // Regular rows get no class
    },
    fetchLeviersStats(){
      let formData = new FormData();
      this.loadingStats = true

       // Vérifier si le client_id est égal à 1
  if (this.client_id == 1) {
    // Générer des données statiques positives
    this.loadingStats = false;
    this.sourceData.overview = this.generateStaticPositiveData();
    
    // Initialiser la recherche après avoir chargé les données
    this.$nextTick(() => {
      this.initializeSearch();
      this.filterData();
      this.refreshChart();
      
      // Définir un score global élevé
      this.globalScore = 75;
    });
    
    // Arrêter l'exécution de la méthode ici
    return;
  }

          if (this.client_id !== undefined && this.client_id !== null && this.client_id !== '') {
            formData.append("client_id", this.client_id);
          }
        
          if (this.categorie !== undefined && this.categorie !== null && this.categorie !== '') {
            formData.append("categorie_id", this.categorie);
          }
          
         
          console.log('formData',formData);
         
            formData.append("date_debut", this.StartDate);
            formData.append("date_fin", this.EndDate);
            let accessToken = localStorage.getItem("token_jwt");
           
            this.axios
                .post(
                    "https://apileadmarket.wee-do-it.net/api/stats-levier",
                    formData,
                    {
                        /* headers: {
                'authorization': `Bearer ${accessToken}`
                } */
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            authorization: `Bearer ${accessToken}`,
                        },
                    }
                )
                .then((response) => {
                    console.log("response: ", response);
                    // Vérifier si la réponse est correcte et contient des données
                    if (response.data && response.data.success && response.data.data) {
                      // Mettre à jour les données du tableau
                      this.loadingStats = false
                      this.sourceData.overview = response.data.data;
                      
                       // Initialiser la recherche après avoir chargé les données
                            this.$nextTick(() => {
                              this.initializeSearch();
                              // Puis filtrer les données si nécessaire
                              this.filterData();
                              this.refreshChart();
                            });
                    } else {
                      console.error("Format de réponse incorrect:", response.data);
                      // Vous pouvez ajouter ici une notification d'erreur pour l'utilisateur
                    }
                    
                    if (response.data && response.data.globalScore) {
                      this.globalScore = response.data.globalScore;
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.loadingStats = false;
                });

    },
    getScoreDescription(score) {
      if (score >= 90) return 'Exceptional Performance! 🌟';
      if (score >= 80) return 'Excellent Performance! 🚀';
      if (score >= 70) return 'Great Performance! 👍';
      if (score >= 60) return 'Good Performance! 👌';
      if (score >= 50) return 'Average Performance 🤔';
      return 'Needs Improvement 💪';
    },
    // Initialisation de la recherche
    initializeSearch() {
      // Make sure we have data before initializing search
      if (this.sourceData && this.sourceData.overview && this.sourceData.overview.length > 0) {
        // Create a deep copy of the data to avoid references issues
        const searchableData = JSON.parse(JSON.stringify(this.sourceData.overview));
        this.fuseSearch = new Fuse(searchableData, this.options);
        console.log('Search initialized with', searchableData.length, 'items');
      } else {
        console.warn('No data available for search initialization');
      }
    },
  }
}
</script>

<style>
.text-gradient {
  background: linear-gradient(to right, #4f46e5, #7c3aed);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

 

.chart-container {
  height: 400px;
}

.text-purple {
  color: #1471f4
}

.stats-table-rows {
  text-transform: uppercase;
}

.fixed-min-height {
  min-height: 250px;
}

/* Fix for Bootstrap dropdowns */
.dropdown-menu.show {
  display: block;
}

.bg-gradient-primary-2 {
  /* Adjust the colors and angle to your liking */
  background: linear-gradient(90deg, #007bff 0%, #6f42c1 100%) !important;
}

.card-custom {
  /* Optional: a bit of rounding or shadow to match the style */
  border-radius: 0.75rem;
  overflow: hidden;
}

.fas.fa-chevron-down {
  transition: transform 0.2s ease;
}
.rotate-180 {
  transform: rotate(180deg);
}

.active-dropdown-item {
  background-color: #f0f9ff !important;
  color: #1471f4 !important;
}

.el-dropdown-menu__item {
  padding: 0 10px !important;
}

.el-dropdown-menu__item div {
  padding: 5px 0;
}

.w-100 {
  width: 100%;
}



.el-dropdown {
    border-radius: 6px;
    background-color: #000000;
    color: #fff !important;
}


.el-dropdown button {
    color: #fff !important;
}

.rightsearch {
    float: right !important;
    position: absolute;
    right: 0;
}
.sub-sources-table {
  background-color: transparent;
  margin-bottom: 0;
}

.pl-5 {
  padding-left: 2rem !important;
}

/* Ajustez l'apparence des sous-lignes */
.sub-sources-table .el-table__row {
  background-color: transparent !important;
}
/* Indicateur visuel pour montrer la relation hiérarchique */
.sub-sources-table .el-table__row td:first-child::before {
  content: "└─";
  color: #6c757d;
  margin-right: 5px;
}
/* Supprimer les bordures superflues */
.sub-sources-table td {
  border-bottom: none;
}

.sub-sources-table tr:last-child td {
  border-bottom: 1px solid #ebeef5;
}
.sub-sources-container {
  padding: 0;
  background-color: rgba(20, 25, 45, 0.02); /* Légèrement plus foncé que le fond */
}

.sub-sources-table::before {
  display: none; /* Supprime la ligne de bordure supérieure */
}
.el-table__expanded-cell {
  padding: 0 !important;
}

.el-table__expanded-cell[class*=cell] {
  padding: 0 !important;
}

.btn-primary {
    width: 100%;
    height: 40px; /* Ajustez selon la hauteur de vos datepickers */
    margin-top: 1px; /* Alignement vertical */
}

.mt-3 {
    margin-top: 1rem;
}
/*.search-input{
  width: 17% !important;
  float: right !important;
}*/
.total-row {
  background-color: rgba(20, 25, 45, 0.05) !important;
  font-weight: bold;
  position: relative; /* Important pour le z-index */
  z-index: 2; /* Mettre la ligne TOTAL au-dessus des autres */

}

.total-row td {
  border-top: 2px solid #dcdfe6 !important;
}

.text-primary {
  color: #409EFF !important;
}
/* Add new styles for zero values */
.text-danger {
  color: #dc3545 !important;
}
.search-input-full {
  width: 100% !important;
  max-width: 100%;
}
.no-expand .el-table__expand-icon {
  display: none !important;
}
/* Désactiver le hover sur la ligne TOTAL pour le tri */
.el-table__body tr.total-row:hover > td {
  background-color: rgba(20, 25, 45, 0.05) !important;
  cursor: default !important;
}
/* Masquer le triangle indicateur de tri lorsqu'il est sur la ligne TOTAL */
.el-table__body tr.total-row .caret-wrapper {
  display: none !important;
}
/* Assurer que la dernière ligne a toujours une bordure inférieure */
.el-table__row:last-child td {
  border-bottom: 1px solid #EBEEF5 !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  background-color: #13141e;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.loading-spinner i {
  color: #1471f4;
}
</style>

